module.exports = __webpack_public_path__ + "img/thumbnail_AfricanPenguin_m_normal.82f1956e.png";